import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["personalField", "companyField", "naturalPersonField", "donationField"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    // 自動偵測 form name pattern（支援 participant_profile 和 order）
    let invoiceType = this.element.querySelector('input[name="participant_profile[invoice_type]"]:checked')?.value
    if (!invoiceType) {
      invoiceType = this.element.querySelector('input[name="order[invoice_type]"]:checked')?.value
    }

    // 先隱藏並 disable 所有欄位
    this.hideAndDisableAllFields()

    // 根據 invoiceType 顯示並 enable 對應欄位
    switch(invoiceType) {
      case "personal":
        this.showPersonalFields()
        break
      case "company":
        this.showCompanyFields()
        break
      case "natural_person":
        this.showNaturalPersonFields()
        break
      case "donation":
        this.showDonationFields()
        break
    }
  }

  hideAndDisableAllFields() {
    if (this.hasPersonalFieldTarget) {
      this.personalFieldTarget.classList.add("hidden")
      const inputs = this.personalFieldTarget.querySelectorAll('input, select, textarea')
      inputs.forEach(input => input.disabled = true)
    }

    if (this.hasCompanyFieldTarget) {
      this.companyFieldTargets.forEach(field => {
        field.classList.add("hidden")
        const inputs = field.querySelectorAll('input, select, textarea')
        inputs.forEach(input => input.disabled = true)
      })
    }

    if (this.hasNaturalPersonFieldTarget) {
      this.naturalPersonFieldTarget.classList.add("hidden")
      const inputs = this.naturalPersonFieldTarget.querySelectorAll('input, select, textarea')
      inputs.forEach(input => input.disabled = true)
    }

    if (this.hasDonationFieldTarget) {
      this.donationFieldTarget.classList.add("hidden")
      const inputs = this.donationFieldTarget.querySelectorAll('input, select, textarea')
      inputs.forEach(input => input.disabled = true)
    }
  }

  showPersonalFields() {
    if (this.hasPersonalFieldTarget) {
      this.personalFieldTarget.classList.remove("hidden")
      const inputs = this.personalFieldTarget.querySelectorAll('input, select, textarea')
      inputs.forEach(input => input.disabled = false)
    }
  }

  showCompanyFields() {
    if (this.hasCompanyFieldTarget) {
      this.companyFieldTargets.forEach(field => {
        field.classList.remove("hidden")
        const inputs = field.querySelectorAll('input, select, textarea')
        inputs.forEach(input => input.disabled = false)
      })
    }
  }

  showNaturalPersonFields() {
    if (this.hasNaturalPersonFieldTarget) {
      this.naturalPersonFieldTarget.classList.remove("hidden")
      const inputs = this.naturalPersonFieldTarget.querySelectorAll('input, select, textarea')
      inputs.forEach(input => input.disabled = false)
    }
  }

  showDonationFields() {
    if (this.hasDonationFieldTarget) {
      this.donationFieldTarget.classList.remove("hidden")
      const inputs = this.donationFieldTarget.querySelectorAll('input, select, textarea')
      inputs.forEach(input => input.disabled = false)
      
      // 觸發 Tom Select 更新
      const tomSelectElement = this.donationFieldTarget.querySelector('[data-controller~="tom-select"]')
      if (tomSelectElement && tomSelectElement.tomselect) {
        tomSelectElement.tomselect.sync()
      }
    }
  }
}
